var $ = require('jquery');
var Provider = require('./Provider');
var siteadmin = require('diy/site-admin/main/siteadmin');

/**
 * Search provider class for searching in various sitebuilder features, with custom actions
 */
(function() {
    'use strict';

    /**
     * @type {Object.<String, Function>} a map of featureId, custom action function
     */
    var actions = {
        tour: function() {
            diy.editor.guidance.start();
        },
        getFound: function () {
            var navigate = function () {
                     parent.diy.editor.deeplinking.requestPath([
                        {label: 'siteadmin', params:'get-found'},
                        {label: 'SAC.GetFound', params: 'get-found-introduction'}
                    ]);
            };

            if (siteadmin.getController() === null) {
                parent.diy.editor.deeplinking.requestPath([ {label: 'siteadmin', params:'get-found'}]);
                $(document).one('diy-siteadmin-content-loaded', navigate);
            } else {
                navigate();
            }

        },
        listLocal: function () {
            var navigate = function () {
                parent.diy.editor.deeplinking.requestPath([
                    {label: 'siteadmin', params:'get-found'},
                    {label: 'SAC.GetFound', params: 'get-found-lilo'}
                ]);
            };
            if (siteadmin.getController() === null) {
                parent.diy.editor.deeplinking.requestPath([ {label: 'siteadmin', params:'get-found'}]);
                $(document).one('diy-siteadmin-content-loaded', navigate);
            } else {
                navigate();
            }

        }
    };

    var Features = Provider.extend({
        indexUrl: '/app/cms/search/featuresindex/',

        initialize: function() {
            this.indexUrl += '?cacheKey=' + jimdoData.search.featuresCacheKey;
        },

        action: function(feature) {
            var actionFn = actions[feature.id];

            if (typeof actionFn === 'function') {
                actionFn();
            }
        }
    });

   module.exports = Features;

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/search/providers/Features.js
 ** module id = 852
 ** module chunks = 0
 **/